<template>
  <tr v-if="thumb">
    <td>
      <img v-if="thumb.thumb" :src="thumb.thumb"  class="fid-upload-thumb">
      <v-icon v-else>insert_drive_file</v-icon>
    </td>
    <td>
      {{ thumb.status || '-' }}
    </td>
    <td v-if="!brief">
      <v-switch
        v-model="retain"
      ></v-switch>
    </td>
    <td  v-if="!brief">
      <v-switch
        v-model="original"
      ></v-switch>
    </td>
    <td  v-if="!brief">
      {{ (thumb.dimensions && thumb.dimensions.height) || '-' }}
    </td>
    <td  v-if="!brief">
      {{ (thumb.dimensions && thumb.dimensions.width) || '-' }}
    </td>
    <td v-if="!brief">
      <a v-if="thumb.signedUrl" :href="`${thumb.signedUrl}`" target="_blank">image</a>
      <span v-else>-</span>
    </td>
    <td>
      {{ thumb.file.name }}
    </td>
    <td>
      {{ thumb.file.type }}
    </td>
    <td>
      {{ filesize(thumb.file.size) }}
    </td>
    <td>
      {{ thumb.file.lastModifiedDate ? thumb.file.lastModifiedDate.toLocaleDateString() : '-' }}
    </td>
  </tr>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'

import filesize from 'filesize'
export default {
  props: {
    thumb: Object,
    brief: Boolean
  },
  computed: {
    original: {
      get () {
        return this.thumb.original
      },
      set (value) {
        this.setThumb({
          property: 'original',
          value,
          index: this.thumb.index
        })
      }
    },
    retain: {
      get () {
        return this.thumb.retain
      },
      set (value) {
        this.setThumb({
          property: 'retain',
          value,
          index: this.thumb.index
        })
      }
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  methods: {
    filesize (size) {
      return filesize(size)
    },
    ...mapMutations(vxMaps.mutations),
  }
}
</script>
